import {GetSeferData} from "SeferPetach/GetData";

export async function getTeachingStructureList(list_type) {
    let ipoint = "";
    switch (list_type) { 
        case 1:
            ipoint = "tssf1";
            break;
        case 2:
            ipoint = "tsaf1";
            break;
        case 3:
            ipoint = "tspf1";
            break;
        case 4:
            ipoint = "tscf1";
            break;
        case 5:
            ipoint = "tsaaf1";
            break;
        case 6:
            ipoint = "tscif1";
            break;
        case 7:
            ipoint = "tsecf1";
            break;
        case 8:
            ipoint = "tsdif1"; 
            break;
        case 9:
            ipoint = "tsdef1";
            break;
        case 10:
            ipoint = "tsclf1";
            break;
        default: 
            break;
    }
    var args = {};
    var payload = await GetSeferData(ipoint, args);
    return (payload);
}

export async function getSchoolByID(item_id){
    var args = {
        'SCHOOL_ID': item_id
    };
    var payload = await GetSeferData("tssf7", args);
    return (payload);
}
export async function getAreaByID(item_id){
    var args = {
        'AREA_ID': item_id
    };
    var payload = await GetSeferData("tsaf7", args);
    return (payload);
}
export async function getProgramByID(item_id){
    var args = {
        'PROGRAM_ID': item_id
    };
    var payload = await GetSeferData("tspf7", args);
    return (payload);
}
export async function getCustomerByID(item_id){
    var args = {
        'CLIENT_ID': item_id
    };
    var payload = await GetSeferData("tscf7", args);
    return (payload);
}
export async function getAcademicAreaByID(item_id){
    var args = {
        'ACADEMIC_AREA_ID': item_id
    };
    var payload = await GetSeferData("tsaaf7", args);
    return (payload);
}
export async function getCourseByID(item_id){
    var args = {
        'COURSE_ID': item_id
    };
    var payload = await GetSeferData("tscif4", args);
    return (payload);
}
export async function getExternalCourseByID(item_id){
    var args = {
        'EXTERNAL_COURSE_ID': item_id
    };
    var payload = await GetSeferData("tsecf4", args);
    return (payload);
}
export async function getDepartmentByID(item_id){
    var args = {
        'DEPARTMENT_ID': item_id
    };
    var payload = await GetSeferData("tsdif4", args);
    return (payload);
}
export async function getExternalDepartmentByID(item_id){
    var args = {
        'EXTERNAL_DEPARTMENT_ID': item_id
    };
    var payload = await GetSeferData("tsdef4", args);
    return (payload);
}
export async function getClassByID(item_id){
    var args = {
        'CLASS_ID': item_id
    };
    var payload = await GetSeferData("tsclf4", args);
    return (payload);
}

export async function updateSchool(obj) {
    var args = obj;
    var payload = await GetSeferData("tssf2", args);
    return (payload);
}
export async function deleteSchool(school_id){
    var args = {
        'SCHOOL_ID': school_id
    };
    var payload = await GetSeferData("tssf3", args);
    return (payload);
}
export async function updateArea(obj) {
    var args = obj;
    var payload = await GetSeferData("tsaf2", args);
    return (payload);
}
export async function deleteArea(area_id){
    var args = {
        'AREA_ID': area_id
    };
    var payload = await GetSeferData("tsaf3", args);
    return (payload);
}
export async function updateProgram(obj) {
    var args = obj;
    var payload = await GetSeferData("tspf2", args);
    return (payload);
}
export async function deleteProgram(program_id){
    var args = {
        'PROGRAM_ID': program_id
    };
    var payload = await GetSeferData("tspf3", args);
    return (payload);
}
export async function updateCustomer(obj) {
    var args = obj;
    var payload = await GetSeferData("tscf2", args);
    return (payload);
}
export async function deleteCustomer(client_id){
    var args = {
        'CLIENT_ID': client_id
    };
    var payload = await GetSeferData("tscf3", args);
    return (payload);
}
export async function updateAcademicArea(obj) {
    var args = obj;
    var payload = await GetSeferData("tsaaf2", args);
    return (payload);
}
export async function deleteAcademicArea(academic_area_id){
    var args = {
        'ACADEMIC_AREA_ID': academic_area_id
    };
    var payload = await GetSeferData("tsaaf3", args);
    return (payload);
}
export async function updateCourse(obj){
    var args = obj;
    var payload = await GetSeferData("tscif2", args)
    return (payload);
}
export async function deleteCourse(course_id){
    var args = {
        'COURSE_ID': course_id
    };
    var payload = await GetSeferData("tscif3", args)
    return (payload);
}
export async function updateExternalCourse(obj){
    var args = obj;
    var payload = await GetSeferData("tsecf2", args)
    return (payload);
}
export async function deleteExternalCourse(external_course_id){
    var args = {
        'EXTERNAL_COURSE_ID': external_course_id
    };
    var payload = await GetSeferData("tsecf3", args)
    return (payload);
}
export async function updateDepartment(obj){
    var args = obj;
    var payload = await GetSeferData("tsdif2", args)
    return (payload);
}
export async function deleteDepartment(department_id){
    var args = {
        'DEPARTMENT_ID': department_id
    };
    var payload = await GetSeferData("tsdif3", args)
    return (payload);
}
export async function updateExternalDepartment(obj){
    var args = obj;
    var payload = await GetSeferData("tsdef2", args)
    return (payload);
}
export async function deleteExternalDepartment(external_department_id){
    var args = {
        'EXTERNAL_DEPARTMENT_ID': external_department_id
    };
    var payload = await GetSeferData("tsdef3", args)
    return (payload);
}

export async function updateClass(obj){
    var args = obj;
    var payload = await GetSeferData("tsclf2", args)
    return (payload);
}
export async function deleteClass(class_id){
    var args = {
        'CLASS_ID': class_id
    };
    var payload = await GetSeferData("tsclf3", args)
    return (payload);
}